import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/vi.ts
var add = "Thêm";
var remove = "Xoá";
var removeAll = "Xoá tất cả";
var incomplete = "Xin lỗi, không phải tất cả các trường đều được nhập đúng.";
var submit = "Gửi";
var noFiles = "Chưa chọn file";
var moveUp = "Di chuyển lên";
var moveDown = "Di chuyển xuống";
var isLoading = "Đang tải...";
var loadMore = "Tải thêm";
var next = "Tiếp";
var prev = "Trước";
var addAllValues = "Thêm tất cả các giá trị";
var addSelectedValues = "Thêm các giá trị đã chọn";
var removeAllValues = "Loại bỏ tất cả các giá trị";
var removeSelectedValues = "Loại bỏ các giá trị đã chọn";
var chooseDate = "Chọn ngày";
var changeDate = "Thay đổi ngày";
var close = "Đóng";
var open = "Mở";
var accepted = function({
  name
}) {
  return `Hãy đồng ý với ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} phải sau ${date(args[0])}.`;
  }
  return `${sentence(name)} phải trong tương lai.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} có thể chỉ bao gồm các chữ cái alphabet.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} có thể chỉ bao gồm các chữ cái và chữ số.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} chỉ có thể chứa các chữ cái và khoảng trắng.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} phải chứa các ký tự chữ cái.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} phải chứa chữ cái hoặc số.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} phải chứa chữ cái hoặc dấu cách.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} phải chứa ký hiệu.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} phải chứa chữ hoa.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} phải chứa chữ thường.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} phải chứa số.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} phải là một ký hiệu.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} chỉ có thể chứa chữ hoa.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} chỉ có thể chứa chữ thường.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} phải trước ${date(args[0])}.`;
  }
  return `${sentence(name)} phải trong quá khứ.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Trường này đã được thiết lập sai và không thể gửi.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} phải ở giữa ${a} và ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} không khớp.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} không phải ngày hợp lệ, hãy sử dụng định dạng ${args[0]}`;
  }
  return "Trường này đã được thiết lập sai và không thể gửi.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} phải ở giữa khoảng từ ${date(args[0])} đến ${date(args[1])}.`;
};
var email = "Hãy nhập một địa chỉ email hợp lệ.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} không kết thúc với ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} không phải một giá trị được cho phép.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} phải có độ dài tối thiểu một ký tự.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} phải có độ dài tối đa ${max2} ký tự.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} nên dài ${max2} ký tự.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} phải có độ dài tối thiểu ${min2} ký tự.`;
  }
  return `${sentence(name)} phải có độ dài tối đa trong khoảng từ ${min2} đến ${max2} ký tự.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} không phải một giá trị được cho phép.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name} không thể lớn hơn ${args[0]}.`;
  }
  return `${sentence(name)} phải tối đa bằng ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Định dạng tệp tin này không được phép.";
  }
  return `${sentence(name)} phải là một trong các dạng: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `${name} không thể nhỏ hơn ${args[0]}.`;
  }
  return `${sentence(name)} phải tối thiểu bằng ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `"${value}" không phải giá trị ${name} được phép.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} phải là một số.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" hoặc ")} cần có.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} là bắt buộc.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} không bắt đầu với ${list(args)}.`;
};
var url = function() {
  return `Vui lòng nhập một URL hợp lệ.`;
};
var invalidDate = "Ngày đã chọn không hợp lệ.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var vi_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, vi_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=vi.mjs.map